(function (scope) {
  'use strict';
  const valid = value => value === 'A' || value === 'B';
  function selectVariant(explicit, saved, random) {
    return valid(explicit) ? explicit : valid(saved) ? saved : random() < 0.5 ? 'A' : 'B';
  }
  function route(url, variant, config) {
    const u = new URL(url, config.origin);
    if (!valid(variant) || u.origin !== config.origin) return u.href;
    if (u.pathname === config.root) u.searchParams.set('view', 'pf-ab-' + variant.toLowerCase());
    if (u.pathname === config.productUrl) u.searchParams.set('view', 'pf-ab-' + variant.toLowerCase());
    return u.href;
  }
  function attributes(variant, experiment) {
    if (!valid(variant)) throw new Error('Invalid variant');
    return { pf_experiment: experiment, pf_variant: variant };
  }
  function cleanAddress(url) {
    const u = new URL(url);
    if (/^pf-ab-[ab]$/.test(u.searchParams.get('view') || '')) u.searchParams.delete('view');
    return u.href;
  }
  function item(config, variant, quantity, subscribe) {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) throw new Error('Choose a quantity from 1 to 10.');
    if (!config.available || config.currency !== 'USD' || config.price !== 6000) throw new Error('This offer is unavailable. Please review the product configuration.');
    const result = { id: config.variantId, quantity, properties: { _pf_experiment: config.experiment, _pf_variant: variant } };
    if (subscribe) {
      if (!config.planAttached || config.planPrice !== 4800) throw new Error('The $48 every-14-days plan is not available for this product yet.');
      result.selling_plan = config.planId;
    }
    return result;
  }
  async function request(fetcher, endpoint, payload) {
    const response = await fetcher(endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    let body;
    try { body = await response.json(); } catch (_) { throw new Error('The store returned an unreadable response. Check your cart before retrying.'); }
    if (!response.ok) throw new Error(body.description || body.message || 'The store could not complete this action.');
    return body;
  }
  async function add(fetcher, config, variant, quantity, subscribe) {
    const line = item(config, variant, quantity, subscribe);
    const attribution = attributes(variant, config.experiment);
    const cart = await request(fetcher, config.root + 'cart/update.js', { attributes: attribution });
    if (cart.attributes?.pf_variant !== variant || cart.attributes?.pf_experiment !== config.experiment) throw new Error('Cart attribution was not saved. No item was added.');
    try { return await request(fetcher, config.root + 'cart/add.js', { items: [line] }); }
    catch (error) { if (error instanceof TypeError || /unreadable response/.test(error.message)) error.uncertain = true; throw error; }
  }
  const api = { selectVariant, route, attributes, item, add, cleanAddress };
  if (typeof module !== 'undefined') module.exports = api;
  if (!scope.document) return;
  const c = scope.PFShopifyDraft;
  if (!c || !c.enabled || !c.shopifyContext) return;
  c.origin = scope.location.origin;
  const query = new URLSearchParams(scope.location.search);
  const incomingAttribution = [...query].filter(([key]) => /^utm_[a-z0-9_]+$/i.test(key));
  try {
    const attributionKey = c.experiment + ':utm';
    if (incomingAttribution.length) scope.sessionStorage.setItem(attributionKey, JSON.stringify(incomingAttribution));
    else for (const [key, value] of JSON.parse(scope.sessionStorage.getItem(attributionKey) || '[]')) {
      if (/^utm_[a-z0-9_]+$/i.test(key) && typeof value === 'string') query.set(key, value);
    }
  } catch (_) {}
  const view = query.get('view');
  const explicit = /^pf-ab-[ab]$/.test(view || '') ? view.endsWith('a') ? 'A' : 'B' : null;
  let saved;
  // Keep a tab's original variant when a separate preview tab changes the
  // shared browser assignment. New tabs still inherit the persistent cohort.
  try { saved = scope.sessionStorage.getItem(c.experiment + ':variant'); } catch (_) {}
  if (!valid(saved)) try { saved = scope.localStorage.getItem(c.experiment); } catch (_) {}
  if (!valid(saved)) saved = scope.document.cookie.match(/(?:^|; )pf_ab_variant=([AB])(?:;|$)/)?.[1];
  const variant = selectVariant(explicit, saved, Math.random);
  try { scope.sessionStorage.setItem(c.experiment + ':variant', variant); } catch (_) {}
  try { scope.localStorage.setItem(c.experiment, variant); } catch (_) {}
  scope.document.cookie = 'pf_ab_variant=' + variant + '; Path=/; SameSite=Lax; Secure';
  c.assignment = variant;
  scope.PFABDraft = api;
  const destination = path => {
    const url = new URL(path, scope.location.href);
    for (const [key, value] of query) if (key.startsWith('utm_') || key === 'preview_theme_id') url.searchParams.set(key, value);
    return url.href;
  };
  const home = route(c.root, variant, c);
  const product = route(c.productUrl, variant, c);
  const rootEntry = scope.location.pathname === c.root;
  const productEntry = scope.location.pathname === c.productUrl;
  if ((rootEntry || productEntry) && !explicit) {
    scope.location.replace(destination(route(scope.location.href, variant, c)));
    return;
  }
  // Shopify has rendered the selected alternate template. Retain its routing
  // links and saved cohort; hide only our internal selector on public pages.
  if (explicit && !c.draftTheme && !query.has('preview_theme_id')) {
    const clean = cleanAddress(scope.location.href);
    if (clean !== scope.location.href) scope.history.replaceState(scope.history.state, '', clean);
    scope.document.title = 'Muscle Arkitekt 01 — Pure Fusion';
  }
  const tag = anchor => {
    const u = new URL(anchor.href, scope.location.href);
    if (u.origin !== c.origin) return;
    // B has no review section: do not expose a shared-menu link to a missing target.
    if (variant === 'B' && u.pathname === c.root && u.hash === '#reviews') {
      anchor.remove();
      return;
    }
    if (anchor.matches('[aria-label="Pure Fusion — home"],.pfh__logo,.wordmark,[data-pf-home]')) anchor.href = home;
    else anchor.href = route(u.href, variant, c);
    const destination = new URL(anchor.href);
    for (const [key, value] of query) if (key.startsWith('utm_') || key === 'preview_theme_id') destination.searchParams.set(key, value);
    anchor.href = destination.href;
  };
  function message(text, error = true) {
    let status = scope.document.getElementById('pf-draft-status');
    if (!status) {
      status = scope.document.createElement('p'); status.id = 'pf-draft-status'; status.setAttribute('tabindex', '-1');
      const buy = scope.document.querySelector('#buy,.pdp__buy') || scope.document.querySelector('main') || scope.document.body;
      buy.prepend(status);
    }
    status.setAttribute('role', error ? 'alert' : 'status'); status.textContent = text; status.focus();
  }
  let busy = false;
  let uncertain = false;
  async function buy(checkout, directCheckout) {
    if (busy) return;
    if (uncertain) { message('The last add may have completed. Review your cart before retrying; reload after confirming its contents.'); return; }
    if (!c.commerceEnabled) { message('Draft preview: commerce is disabled. No cart or order created.'); return; }
    busy = true;
    message(directCheckout ? 'Checking your cart…' : 'Adding to cart…', false);
    const controls = [...scope.document.querySelectorAll('[data-add],[data-add-to-cart],[data-buy-now],[data-buy],[data-now],button[name="checkout"]')];
    controls.forEach(el => { el.setAttribute('aria-disabled', 'true'); if ('disabled' in el) el.disabled = true; });
    try {
      if (directCheckout) {
        const form = scope.document.querySelector('form[action$="/cart"]');
        const updates = form ? [...form.querySelectorAll('[name="updates[]"]')].map(el => {
          const n = Number(el.value); if (!Number.isInteger(n) || n < 0) throw new Error('Cart quantities must be whole numbers, zero or greater.'); return n;
        }) : undefined;
        const cart = await request(scope.fetch.bind(scope), c.root + 'cart/update.js', { ...(updates ? { updates } : {}), attributes: attributes(variant, c.experiment) });
        if (!cart.item_count) throw new Error('Your cart is empty. Add a product before checkout.');
      } else {
        const qty = Number(scope.document.querySelector('[data-qty]')?.value || 1);
        const selected = scope.document.querySelector('[data-plan="subscribe"][aria-pressed="true"],input[name="mode"][value="sub"]:checked');
        await add(scope.fetch.bind(scope), c, variant, qty, Boolean(selected));
      }
      scope.location.assign(destination(checkout ? c.root + 'checkout' : c.root + 'cart'));
    } catch (error) { uncertain = Boolean(error.uncertain); message((uncertain ? 'The add response was interrupted. Review your cart before retrying.' : error.message) + ' No checkout was started.'); }
    finally { busy = false; controls.forEach(el => { el.removeAttribute('aria-disabled'); if ('disabled' in el) el.disabled = false; }); }
  }
  scope.document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]'); if (anchor) tag(anchor);
    const button = event.target.closest('[data-buy-now],[data-add-to-cart],[data-buy],[data-add],[data-now],button[name="checkout"]');
    const checkoutLink = anchor && new URL(anchor.href).pathname === c.root + 'checkout';
    if (!button && !checkoutLink) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const direct = checkoutLink && !button || button?.name === 'checkout';
    if ((scope.location.pathname !== c.productUrl && !c.purchasePage) && !direct) { scope.location.assign(product); return; }
    void buy(Boolean(checkoutLink || button?.matches('[data-buy-now],[data-now],button[name="checkout"]')), direct);
  }, true);
  scope.document.addEventListener('submit', event => {
    if (event.target.matches('form[action$="/cart"]')) {
      if (!c.commerceEnabled) { event.preventDefault(); event.stopImmediatePropagation(); message('Draft preview: cart changes are disabled.'); return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      const form = event.target;
      const update = form.querySelector('button[name="update"]');
      if (update) update.disabled = true;
      void (async () => {
        try {
          const updates = [...form.querySelectorAll('[name="updates[]"]')].map(el => {
            const quantity = Number(el.value);
            if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Cart quantities must be whole numbers, zero or greater.');
            return quantity;
          });
          await request(scope.fetch.bind(scope), c.root + 'cart/update.js', { updates, attributes: attributes(variant, c.experiment) });
          scope.location.assign(destination(c.root + 'cart'));
        } catch (error) { message(error.message); }
        finally { busy = false; if (update) update.disabled = false; }
      })();
      return;
    }
    if (!event.target.matches('[data-pf-popup-signup],[data-signup]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = event.target;
    const signupMessage = form.querySelector('[data-signup-msg]');
    const signupEmail = form.querySelector('input[type="email"]');
    const email = signupEmail?.value.trim() || '';
    const status = text => { if (signupMessage) signupMessage.textContent = text; else message(text); };
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { status('Please enter a valid email.'); return; }
    if (!c.signupEnabled) { status('Email signup is disabled in this QA draft. No email was submitted.'); return; }
    if (form.dataset.pfSignupPending === 'true' || form.dataset.pfSignupComplete === 'true') return;
    const submit = form.querySelector('button[type="submit"]');
    form.dataset.pfSignupPending = 'true';
    if (submit) submit.disabled = true;
    status('Submitting…');
    const nativeForm = scope.document.getElementById('pf-native-signup');
    if (!nativeForm) {
      delete form.dataset.pfSignupPending;
      if (submit) submit.disabled = false;
      status('Signup is unavailable. Please try again later.');
      return;
    }
    // Shopify's customer newsletter form records marketing consent. Let its
    // normal navigation and challenge handling confirm acceptance; never infer
    // success from an opaque AJAX response or retry an uncertain submission.
    nativeForm.querySelector('input[name="contact[email]"]').value = email;
    const returnTo = new URL(destination(home), scope.location.href);
    nativeForm.querySelector('input[name="return_to"]').value = returnTo.pathname + returnTo.search + '#pf-signup-result';
    scope.HTMLFormElement.prototype.requestSubmit.call(nativeForm);
  }, true);
  scope.document.addEventListener('DOMContentLoaded', () => {
    for (const signup of scope.document.querySelectorAll('[data-signup]')) {
      if (!c.signupEnabled) {
        const section = signup.closest('section.signup');
        (section || signup).hidden = true;
        continue;
      }
      if (signup.querySelector('[data-pf-signup-consent]')) continue;
      const consent = scope.document.createElement('p');
      consent.setAttribute('data-pf-signup-consent', '');
      consent.style.cssText = 'font-size:12px;line-height:1.45;margin:8px 0 0';
      consent.textContent = 'By signing up, you agree to marketing emails. Unsubscribe anytime. ';
      const privacy = scope.document.createElement('a');
      privacy.href = c.root + 'policies/privacy-policy';
      privacy.textContent = 'Privacy policy';
      privacy.style.color = 'inherit';
      consent.appendChild(privacy);
      signup.appendChild(consent);
    }
    const narrowHeader = scope.document.createElement('style');
    narrowHeader.textContent = '@media(max-width:380px){.pfh{gap:8px;padding-left:12px;padding-right:12px}.pfh__logo{font-size:17px;gap:6px;min-width:0}.pfh__word{font-size:17px}.pfh__actions{gap:6px}.pfh__cta{padding:8px 10px;font-size:11px}}';
    scope.document.head.appendChild(narrowHeader);
    // Shared draft signup UI. Existing email-send guard remains in force.
    if (c.signupEnabled && (c.purchasePage || query.get('view') === 'pf-ab-a' || query.get('view') === 'pf-ab-b')) {
      const dialog = scope.document.createElement('dialog');
      dialog.id = 'pf-signup-dialog'; dialog.setAttribute('aria-labelledby', 'pf-signup-title');
      dialog.style.cssText = 'border:1px solid #a79155;background:#0e0f11;color:#f7f5ef;padding:0;position:fixed;inset:0;margin:auto;height:fit-content;width:420px;max-width:calc(100vw - 32px);box-sizing:border-box;border-radius:16px;max-height:calc(100dvh - 32px);overflow:hidden;';
      dialog.innerHTML = '<div aria-hidden="true" style="position:absolute;inset:-28px;background-image:url(https://zanybu.github.io/pf-arkitekt-b/assets/img/01-front-shake.jpg);background-size:180% auto;background-position:50% 50%;filter:blur(16px);opacity:.90;pointer-events:none"></div><div aria-hidden="true" style="position:absolute;inset:0;background:rgba(14,15,17,.78);pointer-events:none"></div><div data-pf-signup-content style="position:relative;z-index:1;padding:28px;max-height:calc(100dvh - 34px);overflow-y:auto;box-sizing:border-box"><button type="button" data-pf-signup-close aria-label="Close signup" style="float:right;border:0;background:transparent;color:#f7f5ef;font-size:24px;cursor:pointer">×</button><p style="font-size:12px;letter-spacing:.15em">PURE FUSION</p><h2 id="pf-signup-title" style="font-size:32px;line-height:1.1;margin:16px 0 8px">Sign up and save 15%</h2><p style="margin:0 0 20px">Subscriptions save 20% on every order.</p><form data-pf-popup-signup novalidate><label for="pf-popup-email">Email address</label><input id="pf-popup-email" name="EMAIL" type="email" autocomplete="email" required style="display:block;width:100%;box-sizing:border-box;padding:12px;margin:8px 0;background:#fff;color:#0e0f11;border:1px solid #a79155;border-radius:6px"><button type="submit" style="width:100%;padding:12px;background:#f7f5ef;color:#0e0f11;border:0;border-radius:6px;cursor:pointer">Sign up</button><p style="font-size:12px;line-height:1.45;margin:12px 0 0">15% off a one-time purchase. One use per customer. Excludes subscriptions.</p><p style="font-size:12px;line-height:1.45;margin:8px 0 0">By signing up, you agree to marketing emails. Unsubscribe anytime. <a href="/policies/privacy-policy" style="color:inherit">Privacy policy</a>.</p><p data-signup-msg aria-live="polite"></p></form></div>';
      const signupStyle = scope.document.createElement('style');
      signupStyle.textContent = '#pf-signup-dialog{isolation:isolate;opacity:1!important;filter:none!important;backdrop-filter:none!important;transform:none!important}#pf-signup-dialog [data-pf-signup-content]{filter:none!important;opacity:1!important;transform:none!important;mix-blend-mode:normal!important;color:#f7f5ef!important}#pf-signup-dialog [data-pf-signup-content] *{filter:none!important;opacity:1!important;text-shadow:none!important;font-family:Inter,Arial,sans-serif!important}#pf-signup-dialog #pf-signup-title,#pf-signup-dialog p,#pf-signup-dialog label,#pf-signup-dialog [data-pf-signup-close]{color:#f7f5ef!important}#pf-signup-dialog #pf-signup-title{display:block!important;font-size:32px!important;line-height:1.12!important}#pf-signup-dialog input,#pf-signup-dialog button[type="submit"]{color:#0e0f11!important;background:#f7f5ef!important}#pf-signup-dialog a{color:#f7f5ef!important;text-decoration:underline!important}';
      dialog.appendChild(signupStyle);
      scope.document.body.appendChild(dialog);
      const opener = scope.document.createElement('button');
      opener.type = 'button'; opener.textContent = 'GET 15% OFF'; opener.setAttribute('aria-controls', dialog.id);
      opener.style.cssText = 'position:fixed;left:12px;bottom:80px;z-index:1000;background:#0e0f11;color:#fff;border:1px solid #a79155;padding:10px 14px;cursor:pointer;font:inherit;font-size:12px;';
      scope.document.body.appendChild(opener);
      const filmStage = scope.document.querySelector('#stage');
      let badgeAtBoundary = true, badgePhase = '', badgeWidth = 0, badgeHeight = 0;
      function updateOfferBadge() {
        if (!filmStage) return;
        const progress = Number(filmStage.dataset.progress || 0);
        const phase = progress <= 0.012 ? 'opening' : progress >= 0.995 ? 'ending' : 'middle';
        if (phase === badgePhase && badgeWidth === scope.innerWidth && badgeHeight === scope.innerHeight) return;
        badgePhase = phase; badgeWidth = scope.innerWidth; badgeHeight = scope.innerHeight;
        badgeAtBoundary = phase !== 'middle';
        opener.hidden = !badgeAtBoundary;
        opener.style.display = badgeAtBoundary ? 'block' : 'none';
        if (!badgeAtBoundary) return;
        const homeLink = scope.document.querySelector('header a[aria-label="Pure Fusion — home"]');
        const header = homeLink?.closest('header');
        const purchaseLink = header && [...header.querySelectorAll('a')].find(link => link !== homeLink);
        if (!homeLink || !purchaseLink) { opener.hidden = true; opener.style.display = 'none'; return; }
        const homeBox = homeLink.getBoundingClientRect(), purchaseBox = purchaseLink.getBoundingClientRect();
        const width = Math.min(118, purchaseBox.left - homeBox.right - 8);
        if (width < 26) { opener.hidden = true; opener.style.display = 'none'; return; }
        const compact = width < 100;
        opener.textContent = compact ? '15% OFF' : 'GET 15% OFF';
        opener.setAttribute('aria-label', 'GET 15% OFF');
        opener.style.left = (homeBox.right + 4) + 'px'; opener.style.top = purchaseBox.top + 'px';
        opener.style.bottom = 'auto'; opener.style.width = width + 'px'; opener.style.height = purchaseBox.height + 'px';
        opener.style.boxSizing = 'border-box'; opener.style.padding = compact ? '2px 1px' : '4px 8px';
        opener.style.fontSize = compact ? '10px' : '12px'; opener.style.lineHeight = '1.1'; opener.style.margin = '0';
      }
      if (filmStage) {
        updateOfferBadge();
        new scope.MutationObserver(updateOfferBadge).observe(filmStage, { attributes: true, attributeFilter: ['data-progress'] });
        scope.addEventListener('resize', updateOfferBadge);
      }

      let previousFocus, signupDismissed = false;
      function openSignup() { if(dialog.open)return; previousFocus=scope.document.activeElement; dialog.showModal(); }
      opener.addEventListener('click', openSignup);
      dialog.querySelector('[data-pf-signup-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if(event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close(); } });
      dialog.addEventListener('close', () => { signupDismissed = true; try{scope.sessionStorage.setItem(c.experiment+':signup-seen','1');}catch(_){} if(previousFocus?.isConnected)previousFocus.focus(); });
      let seen=false; try{seen=scope.sessionStorage.getItem(c.experiment+':signup-seen')==='1';}catch(_){}
      if(!seen) scope.setTimeout(() => { let seenNow = false; try { seenNow = scope.sessionStorage.getItem(c.experiment+':signup-seen') === '1'; } catch (_) {} if (!signupDismissed && !seenNow && badgeAtBoundary && !opener.hidden) openSignup(); },12000);
    }

    scope.document.querySelectorAll('a[href]').forEach(tag);
    const drawer = scope.document.querySelector('[data-pf-drawer]');
    const burger = scope.document.querySelector('[data-pf-burger]');
    if (drawer && burger) scope.document.addEventListener('click', event => {
      if (!drawer.hidden && !drawer.contains(event.target) && !burger.contains(event.target)) { drawer.hidden = true; burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', 'Open menu'); }
    });
    scope.document.querySelectorAll('[data-preview-offer]').forEach(el => { el.textContent = c.planAttached && c.planPrice === 4800 ? '$48 billed and shipped every 14 days. Pause, skip or cancel anytime.' : 'Subscriptions are currently unavailable for this product.'; });
  });
})(typeof window === 'undefined' ? {} : window);

